import { useState, useEffect } from 'react';
import Navbar from "./navbar/Navbar";
import Sidebar from "./sidebar/Sidebar";
import { Grid, Box, Toolbar } from '@mui/material';
import { useSelector } from "react-redux";


const Layout = ({ children }) => {
  const state = useSelector((state) => state.userDate);
  const stateSidebar = useSelector((state) => state);
  const [xsSize, setXsSize] = useState(window.innerWidth < 600);

  const handleResizeWindow = () => {
    if(window.innerWidth > 600){
        setXsSize(false);
    } 
    else {
        setXsSize(true);
    } 
  };

  useEffect(() => {
      window.addEventListener('resize', handleResizeWindow);
      return () => {
          window.removeEventListener('resize', handleResizeWindow);
      };
  });


  return (
    <>
      <Box sx={{ display: 'flex' }}>
      {state.token !== undefined && <Navbar initialState={stateSidebar} xsSize={xsSize}/> }
      {state.token !== undefined && <Sidebar initialState={stateSidebar} xsSize={xsSize}/> }
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto'
          }}
        >
          <Toolbar />
          <Grid className="layout-main-grid" container sx={{ pr: 2 , pb:2}} rowSpacing={2} columnSpacing={2}>
              {children}
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default Layout;
